<template>
  <div class="space-y-8">
    <div>
      <CreateNoteAction :contact-id="contactId" @create="refreshList" />
    </div>
    <div class="py-5">
      <NoteList ref="noteList" :contact-id="contactId" @destroy="refreshList" />
    </div>
  </div>
</template>

<script>
import NoteList from './NoteList.vue';
import CreateNoteAction from './CreateNoteAction.vue';

export default {
  components: {
    NoteList,
    CreateNoteAction,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  methods: {
    refreshList() {
      this.$emit('refresh');
      this.$refs.noteList.fetchNotes();
    },
  },
};
</script>
